module.exports = __webpack_public_path__ + "static/media/avatar_9.008fb260.svg";